import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  en: {
    LOGIN: "Login",
    PASSWORD: "Password",
    ADMIN: "admin",
    ForgotYourPassword: "Forgot Password",
    ForgotPassWordMessage: "We get it, stuff happens. just enter your user ID below and we'll send you a link to reset your password!",
    RESETPASSWORD: "Reset Password",
    TEXT: "Text",
    NUMBER: "Number",
    DATE: "Date",
    PHONENUMBER: "Phone number",
    SERVICECATEGORYMASTER: "Service category master",
    SERVICECATEGORYMASTERCREATE: "Service category master> Create",
    SELECTPARENT: "Select parent",
    SERVICENAME: "Service name",
    ICON: "Icon",
    ADDTO: "Save",
    SERVICECATEGORYNAME: "Service category name",
    SUBCATEGORY: "Sub category",
    ACTION: "Action",
    BRINGFIRST: "Bring First",
    PARENTSELECTION: "Parent Selection",
    CLINICNAME: "Clinic Name",
    ADDRESS: "Address",
    PREFECTURES: "Prefectures",
    CITY: "City",
    STREETADDRESS: "Street Address",
    BUILDINGNAME: "Building Name",
    MAILADDRESS: "Mail Address",
    MANAGER: "Manager",
    SURNAME: "Surname",
    AUTHORITY: "Authority",
    PARTNERLIST: "Partners List",
    ADD: "Add",
    STOREMANAGEMENT: "Store Management",
    USER: "A User",
    CREATEUSER: "Create>User",
    BIRTHDATE: "Birth Date",
    COMPANYINFORMATION: "Company Information",
    DELETE: "Delete",
    CLOSE: "Close",
    DELETECONFIRMATION: "Delete Confimation",
    STATUSCHANGECONFIRMATION: "Status Change Confirmation",
    SUCCESSFULLYCONFIRMED: "Success Confimation",
    SUBMIT: "Submit",
    START: "Start",
    END: "End",
    EMAIL: "Email",
    FORWARD: "Forward",
    NEXT: "Next",
    FULLNAME: "Full Name",
    MOBILE: "Mobile Number",
    STATUS: "Status",
    REMEMBERME: "Remember Me",
    NEWPASSWORD: "New Password",
    CONFIRMPASSWORD: "Confirm Password",
    EMAILADDRESS: "Email Address",
    LOGINHERE: "Login Here",
    PARTNERMASTER: "Partner Master",
    NAME: "Name",
    CONTACTNAME: "Contact Name",
    USERNAME: "User Name",
    STORENAME: "Store Name",
    PARTNERMASTERHEADER: "Partner master",
    CANCEL: "Cancel",
    PARTNERMASTERREGISTRED: "Partner master registered",
    MANDATORY: "Please fill the mandatory fields",
    CATEGORYNAME: "Category name",
    POSTALCODE: "Postal code",
    CONTACTFIRSTNAME: "Contact name",
    PARTNERCATEGORYNAME: "Partner category name",
    PARTNERMASTERDELETECONFIRMATION: "Are you sure you want to delete the 'Clinic' partner master?",
    CHANGESTATUSCONFIRMATION: "Are you sure you want to change your status?",
    SERVICECATEGORYMASTERDELETECONFIRMATION: "Are you sure you want to delete the service category master ?",
    SELECTICON: "Select icon",
    SERVICECATEGORYSUCCESS: "Service category master registered",
    DELETEUSERCONFIRMATION: "Are you sure you want to delete the user ?",
    ERROR: "Error",
    IDENTICALPASSWORD: "Passwords must be identical.",
    INVALID: "Invalid",
    PERPAGE: "Per page",
    DESCRIPTION: "説明",
    ROLE: "ROLE",
    REGISTERED: "Registred",
    HIRAGANA: "Hiragana",
    GENDER: "Gender",
    PERSONINCHARGE: "Person Incharge",
    INVALIDEMAIL: "Invalid Mail Address",
    SAMEPASSWORD: "Please Enter Same Password",
    SPECIALPASSWORD: "Must contain at least 10 characters along with one lowercase letter, uppercase letter, number and symbol",
    RANGENOTE: "Must be at least a letter",
    TITLE: "Title",
    PASSWORDVALIDATION: "Phone Number Must Be 10 Digits",
    USERID: "User ID",
    SELECTSURVEY: "Select survey",
    NOMESSAGE: "No Message",
    SENDMESSAGE: "Send Message",
    DATANOTFOUND: "Data not found",
    SUCCESSFULLYCONFIRMEDMASTER: "正常に追加されました",
    PROFILE: "Profile",
    LOGOUT: "Logout",
    PASSWORDRESET: "Password Reset",
    RESET: "Reset",
    CREATE: "Create",
    EDIT: "Edit",
    SUCCESSFULLYDELETEDCONFIRMED: "Succesfully Deleted",
    SUCCESSFULLYADDED: "Successfully added",
    SUCCESSFULLYUPDATED: "Successfully updated",
    SUCCESSFULLYDELETED: "Successfully deleted",
    DELETECONFIRMATIONCOMMOM: "delete？",
    UPLOADLIMITERROR: "If the icon size is more than 512MB, you cannot upload.",
    LOGO: "Logo",
    CHANGE: "Change",
    CHANGEPASSWORD: "Change Password",
    NUMERIC: "This field must be numeric",
    LOGINID: "Login ID",
    EDITITEMNAME: "Edit item name",
    MALE: "Male",
    OTHER: "Other",
    FEMALE: "Femlae",
    NOTIFICATION: "notification",
    DATEFROMTO: "Date From to",
    DESTINATION: "Destination",
    SUBJECT: "Subject",
    NOTIFICATIONSTATUS: "Notification Status",
    CLINICID: "Clinic ID",
    PATIENTID: "Patient ID",
    DASHBOARD: "DashBoard",
    REGISTERDUSER: "Registed Users",
    PARTNERS: "Patients",
    HEADBRANCHUSERS: " Head Branch Users",
    TOTALUSSERS: "Total users",
    PARTNER: "Partner",
    CHANGEPASSWORD1: "Change Password",
    CONFIRMNEWPASSWORD: "Confirm New Password",
    INTERVIEW: "Interview",
    USERDETAILS: "ユーザー詳細",
    CONTENT: "内容",
    AFFILIATEDNAME: "Partner Name",
    SURVEY_SUMMARY: "Survey Summary",
    CATEGORY: "Category",
    SURVEY_DATE: "Survey Date",
    GRADE: "Grade",
    MESSAGE: "Message",
    NO_SURVEY_ANSWER: "No Survey Answer",
    GO_PAGE_TOP: "Go to top of the page",
    PHONEVALIDATION: "Phone number must be 10~11 digits",
    SELECTPROPERDATE: "Select proper date",
    SELECTPROPERTIME: "Select proper time",
    SURVEYQUESTION: "Survey Question",
    INTERVIEWSTATUS: "Notification status",
    INVALIDPHONENO: "Invalid Phone Number",
    DECIMAL: "Decimal",
    REQUIREDFIELD: "required",
    VALIDPASSWORD: "パスワードは少なくとも8文字でなければなりません。",
    UNIQUENUMBER: "Unique number"

  },
  ja: {
    LOGIN: "ログイン",
    PASSWORD: "パスワード",
    ADMIN: "管理者一覧",
    ForgotYourPassword: "パスワードをお忘れですか？",
    ForgotPassWordMessage: "以下にログインIDを入力してください。パスワードをリセットするためのリンクが送信されます。",
    RESETPASSWORD: "パスワードを再設定する",
    TEXT: "テキスト",
    NUMBER: "数字",
    DATE: "年月日",
    PHONENUMBER: "電話番号",
    SERVICECATEGORYMASTER: "サービスマスタ一覧",
    SERVICECATEGORYMASTERCREATE: "サービスマスタ ＞ ",
    SELECTPARENT: "親カテゴリ",
    SERVICENAME: "サービス名",
    ICON: "アイコン",
    ADDTO: "保存",
    SERVICECATEGORYNAME: "サービスマスタ名",
    SUBCATEGORY: "サブカテゴリ",
    ACTION: "アクション",
    BRINGFIRST: "提携先カテゴリマスタ",
    PARENTSELECTION: "提携先",
    CLINICNAME: "クリニック名",
    ADDRESS: "住所〒",
    PREFECTURES: "都道府県",
    CITY: "市区町村",
    STREETADDRESS: "番地・号",
    BUILDINGNAME: "ビル名",
    MAILADDRESS: "メールアドレス",
    MANAGER: "管理者",
    SURNAME: "姓",
    NAME: "名",
    AUTHORITY: "権限",
    PARTNERLIST: "提携先一覧",
    ADD: "追加",
    STOREMANAGEMENT: "店舗管理",
    USER: "ユーザ",
    CREATEUSER: "ユーザ ＞ 作成",
    BIRTHDATE: "生年月日",
    AGE: "年齢",
    COMPANYINFORMATION: "会社情報",
    DELETE: "削除する",
    CLOSE: "OK",
    DELETECONFIRMATION: "削除確認",
    STATUSCHANGECONFIRMATION: "ステータス変更の確認",
    SUCCESSFULLYCONFIRMED: "追加されました。",
    SUCCESSFULLYDELETEDCONFIRMED: "削除されました。",
    SUBMIT: "設定",
    START: "開始",
    END: "終了",
    EMAIL: "メールアドレス",
    FORWARD: "前",
    NEXT: "次",
    FULLNAME: "姓名",
    MOBILE: "電話番号",
    STATUS: "ステータス",
    REMEMBERME: "ログイン状態を保存する",
    NEWPASSWORD: "新しいパスワード",
    CONFIRMPASSWORD: "パスワードを認証する",
    EMAILADDRESS: "電子メールアドレス",
    LOGINHERE: "ここでログイン",
    PARTNERMASTER: "提携先マスタ一覧",
    PERSONINCHARGE: "担当者姓",
    USERNAEM: "ユーザ名",
    STORENAME: "店舗名",
    PARTNERMASTERHEADER: "提携先マスタ  ＞ ",
    CANCEL: "キャンセル",
    PARTNERMASTERREGISTRED: "提携先マスタを登録しました。",
    MANDATORY: "必須項目を入力してください。",
    CATEGORYNAME: "カテゴリ名",
    POSTALCODE: "郵便番号",
    CONTACTFIRSTNAME: "担当者姓",
    PARTNERCATEGORYNAME: "提携先カテゴリ名",
    PARTNERMASTERDELETECONFIRMATION: "「クリニック」提携先マスタを削除してもよろしいですか？",
    CHANGESTATUSCONFIRMATION: "ステータスを変更してもよろしいですか？",
    SERVICECATEGORYMASTERDELETECONFIRMATION: "サービスマスタを削除してもよろしいですか？",
    SERVICECATEGORYDELETED: "サービスカテゴリマスタを削除しました。",
    SELECTICON: "ロゴを選択",
    SELECTICON2: "アイコンを選択",
    SERVICECATEGORYSUCCESS: "サービスカテゴリマスタを登録しました。",
    DELETEUSERCONFIRMATION: "ユーザを削除してもよろしいですか？",
    ERROR: "エラー",
    IDENTICALPASSWORD: "パスワードは同一でなければなりません。",
    INVALID: "無効",
    PERPAGE: "1ページあたり",
    DESCRIPTION: "説明",
    ROLE: "権限",
    REGISTERED: "登録済",
    HIRAGANA: "ひらがな",
    GENDER: "性別",
    INVALIDEMAIL: "無効なメールアドレス",
    SAMEPASSWORD: "同じパスワードを入力してください。",
    SPECIALPASSWORD: "10文字以上で英小文字・英大文字・数・記号それぞれ1文字以上を含むこと。",
    CONTACTNAME: "担当者名",
    RANGENOTE1: "桁の数字を入力してください。",
    RANGENOTE2: "文字でなければなりません",
    USERCREATION: "ユーザが見つかりません。",
    WANTTOCREATE: "ユーザを作成しますか？",
    PASSWORDVALIDATION: "電話番号は10桁でなければなりません。",
    USERID: "ユーザID",
    SELECTSURVEY: "質問を選択",
    USERNAME: "ユーザ名",
    NOMESSAGE: "メッセージなし",
    SENDMESSAGE: "メッセージを送る",
    DATANOTFOUND: "データが見つかりません。",
    SUCCESSFULLYCONFIRMEDMASTER: "追加されました。",
    PROFILE: "プロフィール",
    LOGOUT: "ログアウト",
    RESET: "リセット",
    CREATE: "作成",
    EDIT: "編集",
    PASSWORDRESET: "パスワードのリセット",
    SUCCESSFULLYADDED: "追加されました。",
    SUCCESSFULLYUPDATED: "更新されました。",
    SUCCESSFULLYDELETED: "削除されました",
    DELETECONFIRMATIONCOMMOM: "を削除してもよろしいでしょうか？",
    UPLOADLIMITERROR: "アイコンサイズが512MB以上の場合、アップロードできません。",
    LOGO: "ロゴ",
    CHANGE: "変更する",
    CHANGEPASSWORD: "パスワードの変更",
    NUMERIC: "数字のみを入力してください。",
    LOGINID: "ログインID",
    EDITITEMNAME: "項目名の編集",
    MALE: "男性",
    OTHER: "その他",
    FEMALE: "女性",
    NO_ANSWER: "回答なし",
    NOTIFICATION: "通知",
    DATEFROMTO: "配信日時設定",
    DESTINATION: "配信先",
    SUBJECT: "通知件名",
    NOTIFICATIONSTATUS: "通知ステータス",
    CLINICID: "提携先ID",
    PATIENTID: "患者ID",
    DASHBOARD: "ダッシュボード",
    REGISTERDUSER: "登録ユーザー",
    PARTNERS: "患者",
    HEADBRANCHUSERS: "本社支店のユーザー",
    TOTALUSSERS: "総ユーザー",
    PARTNER: "提携先",
    TITLE: "タイトル",
    CHANGEPASSWORD1: "パスワードの変更",
    CONFIRMNEWPASSWORD: "新しいパスワード (確認)",
    USERDETAILS: "ユーザー詳細",
    CONTENT: "内容",
    AFFILIATEDNAME: "提携先名",
    SURVEY_SUMMARY: "問診結果サマリー",
    CATEGORY: "カテゴリ",
    SURVEY_DATE: "実施日",
    GRADE: "グレード",
    MESSAGE: "メッセージ",
    NO_SURVEY_ANSWER: "未実施",
    GO_PAGE_TOP: "先頭に戻る",
    PHONEVALIDATION: "電話番号は最低10で最大が11である必要です。",
    INVALID_POSTAL_CODE: "半角数字7桁を入力してください。",
    SELECTPROPERDATE: "適切な日付を入力してください 。",
    SELECTPROPERTIME: "適切な時間を入力してください。",
    INTERVIEW: "ヘルスチェック票",
    SURVEYQUESTION: "ヘルスチェック通知設定",
    INTERVIEWSTATUS: "通知設定",
    INVALIDPHONENO: "適切な電話番号を入力してください。（半角数字最低10及び最大11でです)",
    DECIMAL: "有効な数値を入力してください",
    REQUIREDFIELD: "この項目は必須です",
    VALIDPASSWORD: "パスワードは少なくとも8文字でなければなりません。",
    UNIQUENUMBER: "固有番号",
    PATIENT_VR_ID: "VR用ユーザーID",
    INVALID_PATIENT_VR_ID: "半角英数字または半角ハイフンのみ使用可能です。"
  }
};
const i18n = new VueI18n({
  locale: "ja",
  fallbackLocale: "en",
  messages
});

export default i18n;
